class GiftNote extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.key = this.dataset.key;
    this.lineItemIndex = this.dataset.lineItemIndex;
    this.giftwrappedVariantOnly = this.dataset.giftwrappedVariantOnly === "true";
    this.maxWords = parseInt(this.dataset.maxWords || "0");
    this.maxChars = parseInt(this.dataset.maxChars || "0");
    this.formId = this.dataset.formId;
    this.type = this.dataset.type || "product";
    this.title = this.dataset.title || "";
    this.placeholder = this.dataset.placeholder || "";
    this.isAGiftLabel = this.dataset.isAGiftLabel;
    this.canUncheck = this.dataset.canUncheck === "yes";
    this.isAGift = this.dataset.isAGift;
    this.value = this.dataset.value;
    this.showComponent = this.giftwrappedVariantOnly && !this.canUncheck || !this.giftwrappedVariantOnly;

    this.form = this.closest("[data-product-blocks]")?.querySelector(`form[action*="/cart/add"]`);
    if (this.form) {
        const id = this.form.getAttribute("id");
        if (id !== this.formId) {
            this.formId = id;
        }
    }
    this.render();
    this.setup();
    this.syncHiddenFields(); 
  }

  createHiddenInput(name) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.dataset.key=this.key;
    if (this.type === 'complementary-item') {
        input.name = `${name}[${this.key}]`;
    } else {
        input.setAttribute("form", this.formId)        
    };
    this.appendChild(input);
    return input;
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        input[type="checkbox"] {
            -webkit-appearance: none;
            appearance: none;
            width: 18px;
            height: 18px;
            border: 2px solid var(--colorBtnPrimary);
            background-color: transparent;
            cursor: pointer;
            position: relative;
            margin: 0;
        }

        input[type="checkbox"]:checked {
            background-color: var(--colorBtnPrimary);
            border-color: var(--colorBtnPrimary);
            background-image: url("data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgdmlld0JveD0iMCAwIDI0IDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0yMC4yODUgNi43MDhsLTExLjA3NSAxMS4wOC01LjQ5NS01LjQ5IDEuNDE1LTEuNDIgNC4wOCA0LjA3NSA5LjY2LTkuNjY0eiIvPjwvc3ZnPg==");
        }
        input[type="checkbox"]:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }
        textarea {
          width: 100%;
          min-height: 80px;
          resize: vertical;
          border: none;
          background: none;
          border-bottom: 1px solid #000;
          appearance: none;
          border-radius: 0;
        }
        textarea:focus {
          outline: none;
          box-shadow: 0 0 0 2px var(--colorBtnPrimary);
        }
        .counter {
          font-size: 0.9em;
          color: #555;
        }
        h3 {
            font-size: 1rem;
            margin: 0;
            font-weight: normal;
            margin-bottom: 10px;
        }
        label {
          display: flex;
          gap: 8px;
          align-items: center;
          cursor: pointer;          
          font-weight: bold;
          ${this.type === "cart-item" ? 'font-size: 12px;' : 'font-size: 14px;'}
        }
        .hidden {
            display: none;
        }
        .gift-note {
            ${this.type === "cart-item" ? "padding: 20px 20px 10px 0;" : "padding: 0 20px 20px 0;"}            
        }
        .gift-note-section {
            margin-top: 10px;
            background-color: #f2f3f1;
            padding: 10px;
        }
        label.disabled {
            color: #999;
            cursor: not-allowed;
        }
    </style>
      <div data-gift-note class="gift-note ${this.showComponent ? "" : "hidden"}">
            <label data-gift-label title="This is already gift wrapped"'
            } >
                <input type="checkbox" name="properties_${this.isAGiftLabel}]" ${
      this.isAGift && 'checked="checked"'
    }class="is-a-gift-checkbox" />
                ${this.isAGiftLabel}
            </label>
            <div class="gift-note-section ${
              this.isAGift ? "" : "hidden"
            }" data-gift-note>
                ${this.title ? `<h3>${this.title}</h3>` : ""}
                <textarea placeholder="${
      this.placeholder
    }" name="properties_gift_note">${this.value}</textarea>
                <div class="counter" id="wordCountMessage"></div>
            </div>
        </div>
    `;
  }

  setup() {
    this.checkbox = this.shadowRoot.querySelector(".is-a-gift-checkbox");
    this.section = this.shadowRoot.querySelector(".gift-note-section");
    this.component = this.shadowRoot.querySelector("[data-gift-note]");
    this.label = this.shadowRoot.querySelector("[data-gift-label]");
    this.textarea = this.shadowRoot.querySelector("textarea");
    this.message = this.shadowRoot.querySelector("#wordCountMessage");

    this.hiddenInputGift = this.querySelector(`input[name='properties[${this.isAGiftLabel}]'][data-key="${this.key}"]`) ||
      this.createHiddenInput(`properties[${this.isAGiftLabel}]`);
    this.hiddenInputNote = this.querySelector(`input[name='properties[Gift Note]'][data-key="${this.key}"]`) ||
      this.createHiddenInput(`properties[Gift Note]`);

    this.textarea.addEventListener("input", () => {
        this.syncHiddenFields();
        this.updateWordCount();
    });
    this.updateWordCount();
    // Only update cart if this is a cart item
    document.addEventListener('variant:change',this.handleMainVariantChange.bind(this));
    if (this.type === "cart-item") {
      this.checkbox.addEventListener("change", () =>
        this.onGiftCheckboxChange()
      );
      this.textarea.addEventListener("change", () =>
        this.onGiftCheckboxChange()
      );
    } else {
      this.checkbox.addEventListener("change", () => {
            this.handleCheckboxChange();
            this.syncHiddenFields();
        });
    }
  }

  handleMainVariantChange(evt) {
    const variant = evt.detail.variant;
    if (variant && variant.title.includes("Gift Wrapped")) {
      // this.label.classList.add("disabled");
      // this.checkbox.setAttribute("disabled","disabled");
      this.checkbox.checked = true;
      this.showComponent = true;
    } else {
      if (this.giftwrappedVariantOnly) {
        this.checkbox.checked = false;
        // this.checkbox.setAttribute("disabled","disabled");
        // this.label.classList.add("disabled");
        this.showComponent = false;
        this.section.classList.add("hidden");
      } else {
        // this.label.classList.remove("disabled");
        // this.checkbox.removeAttribute("disabled");
        this.showComponent = true;
      }
    }
    this.component.classList.toggle("hidden", !this.showComponent);
    this.handleCheckboxChange();
    this.syncHiddenFields()
  }
  syncHiddenFields() {
    const isChecked = this.checkbox.checked;
    this.hiddenInputGift.value = isChecked ? "yes" : "";
    this.hiddenInputNote.value = isChecked ? this.textarea.value : "";
  }

  handleCheckboxChange() {
    const isChecked = this.checkbox.checked;
    if (isChecked) {
      if (window.sessionStorage) {
        const oldMessage = window.sessionStorage.getItem(
          `gift_previous_note_${this.key}`
        );
        if (oldMessage) {
          this.textarea.value = oldMessage;
          window.sessionStorage.removeItem(`gift_previous_note_${this.key}`);
        }
      }
      this.section.classList.remove("hidden");      
    } else {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(
          `gift_previous_note_${this.key}`,
          this.textarea.value
        );
      }
      this.textarea.value = "";
      this.section.classList.add("hidden");
    }
    this.updateWordCount();
  }

  updateWordCount() {
    let text = this.textarea.value;

    if (this.maxChars > 0 && text.length > this.maxChars) {
      text = text.slice(0, this.maxChars);
    }

    let words = text.trim().split(/\s+/).filter(Boolean);
    if (this.maxWords > 0 && words.length > this.maxWords) {
      text = words.slice(0, this.maxWords).join(" ");
      words = text.trim().split(/\s+/).filter(Boolean);
    }

    this.textarea.value = text;

    const remainingWords =
      this.maxWords > 0 ? this.maxWords - words.length : null;
    const remainingChars =
      this.maxChars > 0 ? this.maxChars - text.length : null;

    const parts = [];
    if (remainingWords !== null) {
      parts.push(
        `${remainingWords} word${remainingWords !== 1 ? "s" : ""} left`
      );
    }
    if (remainingChars !== null) {
      parts.push(
        `${remainingChars} character${remainingChars !== 1 ? "s" : ""} left`
      );
    }

    this.message.textContent = parts.join(", ");
    this.message.style.color =
      remainingWords < 0 || remainingChars < 0 ? "red" : "#555";
  }

  async onGiftCheckboxChange() {
    const isGift = this.checkbox.checked;
    const overlay = document.querySelector(".cart-loading-overlay");
    overlay && (overlay.hidden = false);

    try {
      const cart = await theme.cart.getCart();
      const item = cart.items.find((i) => i.key === this.key);
      if (!item) throw new Error("Item not found in cart");

      const cartItem = document.querySelector(
        `.cart__item[data-key="${this.key}"]`
      );
      if (!cartItem) throw new Error("Cart DOM element not found");

      const quantityInput = cartItem.querySelector(".js-qty__num");
      const currentQuantity = parseInt(quantityInput.value);

      const updatedProperties = {
        ...item.properties,
        [this.isAGiftLabel]: isGift ? "yes" : "",
        "Gift Note": isGift ? this.textarea.value : "",
      };

      const response = await theme.cart._updateCart({
        url: `${theme.routes.cartChange}?t=${Date.now()}`,
        data: JSON.stringify({
          id: item.key,
          quantity: currentQuantity,
          properties: updatedProperties,
        }),
      });

      const updatedCart = JSON.parse(response);
      const requiresMessage = updatedCart.items.some(
        (item) =>
          item.properties[this.isAGiftLabel] === "yes" ||
          item.variant_title.includes("Gift Wrapped")
      );

      if (requiresMessage) {
        if (window.sessionStorage) {
          const oldMessage = window.sessionStorage.getItem(
            `gift_previous_note_${this.key}`
          );
          if (oldMessage) {
            this.textarea.value = oldMessage;
            window.sessionStorage.removeItem(`gift_previous_note_${this.key}`);
          }
        }
        this.section.classList.remove("hidden");
        this.updateWordCount();
      } else {
        if (window.sessionStorage) {
          window.sessionStorage.setItem(
            `gift_previous_note_${this.key}`,
            this.textarea.value
          );
        }
        this.textarea.value = "";
        this.section.classList.add("hidden");
      }

      document.dispatchEvent(new CustomEvent("cart:build"));
    } catch (err) {
      console.error("Gift note update error:", err);
    } finally {
      overlay && (overlay.hidden = true);
    }
  }
}

customElements.define("gift-note", GiftNote);
